import API from '../dataApi';

// -- Settings ------------------------------------------------------------------
export const getSubscriptionPlans = (email) =>
  API.get('/settings/subscription-plans', email ? { params: { email } } : undefined);

export const getAdminSubscriptionPlans = () =>
  API.get('/settings/subscription-plans/admin');

export const updateSubscriptionPlans = (plans) =>
  API.put('/settings/subscription-plans', { plans });

export const deleteSubscriptionPlan = (id) =>
  API.delete(`/settings/subscription-plans/${id}`);
